import React, { ReactNode, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import axios, { ErrorResponse } from '../../libraries/axios/axios';
import { apiRoutes } from '../../../config/api/apiRoutes';
import {
  getLocalStorageValue,
  LocalStorageKey,
} from '../../utils/localStorage/localStorage';

type HealthProviderProps = {
  children: ReactNode;
  onHasNewVersion: (newVersion: string) => void;
};

export const HealthProvider = ({
  children,
  onHasNewVersion,
}: HealthProviderProps) => {
  const { mutate: getVersion, data: versionResponse } = useMutation<
    { data: string },
    ErrorResponse
  >({
    mutationFn: () => {
      return axios.get(apiRoutes.health.version);
    },
  });

  useEffect(() => {
    getVersion();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      getVersion();
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (
      versionResponse &&
      versionResponse.data !== getLocalStorageValue(LocalStorageKey.version)
    ) {
      onHasNewVersion(versionResponse.data);
    }
  }, [versionResponse?.data]);

  return <>{children}</>;
};

export default HealthProvider;
